// extracted by mini-css-extract-plugin
export default {"cEditor":"style_cEditor__nN4-0","inherit":"style_inherit__Z9GtL"};